"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNSnackbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      color: 'white',
      textDecoration: 'underline',
      fontWeight: 800
    },
    snackbar: {
      background: function background(props) {
        return props.cssProps ? props.cssProps.background : 'red';
      },
      fontWeight: 600
    },
    rootSnackbar: {
      display: 'block',
      width: theme.custom.defaultSnackbar.width,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  };
});

/**
 *
 * A default VNSnackbar that is set to our VN Style and design.
 * Currently you should use an alert OR an action to display the snackbar.
 *
 * Requires you to set and maintain snackbar data object outside this during implementation
 * Example:
 * setSnackbarData({
 *           open: true,
 *          action: {
 *            title: t('SIGN_UP'),
 *            onClick: () => {
 *              history.push('/profile/signup')
 *            }
 *          },
 *          cssProps: {
 *            background: 'red',
 *          },
 *          message: t('NO_PHONE_USER_EXISTS'),
 *        })
 *
 * const displaySnackbar = () => {
 *  if (snackbarData.hasOwnProperty('open')) {
 *    return(<VNSnackbar  cssProps={snackbarData.cssProps ? snackbarData.cssProps : null}
 *                        alert={snackbarData.alert ? snackbarData.alert : null}
 *                        action={snackbarData.action ? snackbarData.action : null}
 *                        message={snackbarData.message}
 *                        open={snackbarData.open}
 *                        onHandleClose={() => {setSnackbarData({})}} />)
 *  }
 *}
 *
 * @props
 *
 * Required
 * open: Boolean - true to show it, false otherwise
 * message: String - What to display in the snackbar
 * cssProps: Obj -
 *              - background: String: The color you want the snackbar to be if you are using an action
 *
 * Optional
 * autoHideDuration: int | null - (Default: 5000) - how long until the snackbar auto closes, auto hide will be disabled if it is null
 * onHandleClose: func - is callack automatically when the snackbar is closed
 * alert: String - Shows an alert message - Options: 'success', 'error', 'warning', 'info'
 * action: Obj -
 *              - title: The button title to show as the action
 *              - onClick: func: What happens when the action button is clicked?
 */
var VNSnackbar = function VNSnackbar(props) {
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)();

  //  HANDLES

  // onClose event
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    if (props.onHandleClose) {
      props.onHandleClose();
    }
  };
  var handleExit = function handleExit() {
    if (props.onHandleClose) {
      props.onHandleClose();
    }
  };

  // displays an alert message, these do NOT have buttons for actions, just a notice of sorts
  var displayAlert = function displayAlert() {
    if (props.alert) {
      return /*#__PURE__*/_react.default.createElement(_Alert.default, {
        elevation: 6,
        variant: "filled",
        onClose: handleClose,
        severity: props.alert
      }, props.message);
    }
  };

  // displays an actionable message with button that you can click on
  var displayAction = function displayAction() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: classes.button,
      size: "small",
      onClick: function onClick() {
        props.action.onClick();
        handleClose();
      }
    }, props.action.title), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      size: "small",
      "aria-label": "close",
      color: "inherit",
      onClick: handleClose
    }, /*#__PURE__*/_react.default.createElement(_Close.default, {
      fontSize: "small"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    classes: {
      root: classes.rootSnackbar
    },
    ContentProps: {
      classes: {
        root: classes.snackbar
      }
    },
    open: props.open,
    autoHideDuration: props.autoHideDuration || props.autoHideDuration === null ? props.autoHideDuration : 5000,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: theme.custom.defaultSnackbar.textAlign
    },
    action: props.action ? displayAction() : null,
    onClose: handleClose,
    onExited: handleExit,
    message: props.alert ? null : props.message
  }, displayAlert());
};
exports.VNSnackbar = VNSnackbar;